module.exports = __webpack_public_path__ + "img/T004_150ppi.90d7e25f.png";